export default "__VITE_ASSET__DjS_twHn__"